import React, { Component } from 'react';

import BasicPageWrapper from '../../components/basicPageWrapper';
import ContactModal from '../../components/contactModal';

class FourOhFour extends Component {
  render() {
    return (
      <BasicPageWrapper title={'An error occurred'}>
        <div>
          <p>
            Hi there, it looks like something went wrong on our end. Please
            refresh your page to try again.
          </p>
          <p>If the problem persists, please contact support.</p>
          <ContactModal>
            <a className="button button--secondary mt10 mb10">Contact Us</a>
          </ContactModal>
        </div>
      </BasicPageWrapper>
    );
  }
}

export default FourOhFour;



// WEBPACK FOOTER //
// ./src/routes/404/index.js